import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeNavigationLinkSkeleton } from "./TypeNavigationLink";

/**
 * Fields type definition for content type 'TypeNavigationContainer'
 * @name TypeNavigationContainerFields
 * @type {TypeNavigationContainerFields}
 * @memberof TypeNavigationContainer
 */
export interface TypeNavigationContainerFields {
    /**
     * Field type definition for field 'internalName' (Internal Name)
     * @name Internal Name
     * @localized false
     */
    internalName: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'logo' (Logo)
     * @name Logo
     * @localized false
     */
    logo?: EntryFieldTypes.AssetLink;
    /**
     * Field type definition for field 'label' (Label)
     * @name Label
     * @localized true
     */
    label: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'homeUrl' (Home URL)
     * @name Home URL
     * @localized false
     */
    homeUrl?: EntryFieldTypes.EntryLink<TypeNavigationLinkSkeleton>;
    /**
     * Field type definition for field 'listOfLinks' (List of links)
     * @name List of links
     * @localized false
     */
    listOfLinks?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeNavigationLinkSkeleton>>;
    /**
     * Field type definition for field 'disableSignIn' (DisableSignIn)
     * @name DisableSignIn
     * @localized false
     */
    disableSignIn?: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'uiTheme' (UI Theme)
     * @name UI Theme
     * @localized false
     */
    uiTheme?: EntryFieldTypes.Symbol<"movingworlds" | "transform">;
}

/**
 * Entry skeleton type definition for content type 'navigationContainer' (NavigationContainer)
 * @name TypeNavigationContainerSkeleton
 * @type {TypeNavigationContainerSkeleton}
 * @author 1elSikqsztE4ExkC29eZFE
 * @since 2021-04-13T09:33:09.835Z
 * @version 23
 */
export type TypeNavigationContainerSkeleton = EntrySkeletonType<TypeNavigationContainerFields, "navigationContainer">;
/**
 * Entry type definition for content type 'navigationContainer' (NavigationContainer)
 * @name TypeNavigationContainer
 * @type {TypeNavigationContainer}
 * @author 1elSikqsztE4ExkC29eZFE
 * @since 2021-04-13T09:33:09.835Z
 * @version 23
 */
export type TypeNavigationContainer<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeNavigationContainerSkeleton, Modifiers, Locales>;

export function isTypeNavigationContainer<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeNavigationContainer<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'navigationContainer'
}
